// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.profile.RentalManagerUserProfileV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserProfileV2WebApiHandler_saveUserInfo,
  RentalManagerUserProfileV2WebApiHandler_setName,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserProfileSaveUserInfoV2RequestDto,
  UserProfileSetNameV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserProfileV2WebApiHandler_saveUserInfo_Args {
  postData: UserProfileSaveUserInfoV2RequestDto;
}

export type RentalManagerUserProfileV2WebApiHandler_saveUserInfo_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserProfileV2WebApiHandler_saveUserInfo_Args
>;

/**
 * Set user info
 */
export const useRentalManagerUserProfileV2WebApiHandler_saveUserInfo = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserProfileV2WebApiHandler_saveUserInfo_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserProfileV2WebApiHandler_saveUserInfo_Args) =>
      RentalManagerUserProfileV2WebApiHandler_saveUserInfo(args.postData, httpClient),
  });
};

export interface RentalManagerUserProfileV2WebApiHandler_setName_Args {
  postData: UserProfileSetNameV2RequestDto;
}

export type RentalManagerUserProfileV2WebApiHandler_setName_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserProfileV2WebApiHandler_setName_Args
>;

/**
 * Set user's name
 */
export const useRentalManagerUserProfileV2WebApiHandler_setName = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserProfileV2WebApiHandler_setName_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserProfileV2WebApiHandler_setName_Args) =>
      RentalManagerUserProfileV2WebApiHandler_setName(args.postData, httpClient),
  });
};
